const BLOCKED_PREFIXES = ['/login', '/forgot-password', '/reset-password', '/change-password']

export function sanitizeRedirectPath(input: unknown): string | null {
  if (typeof input !== 'string') return null
  if (input.length === 0 || input.length > 2000) return null
  if (!input.startsWith('/')) return null
  if (input.startsWith('//')) return null
  if (input.includes('\\')) return null
  if (/\s/.test(input)) return null
  for (let i = 0; i < input.length; i++) {
    const code = input.charCodeAt(i)
    if (code < 0x20 || code === 0x7f) return null
  }
  const pathOnly = input.split(/[?#]/)[0]
  if (BLOCKED_PREFIXES.some((p) => pathOnly.toLowerCase() === p || pathOnly.toLowerCase().startsWith(p + '/'))) return null

  // Sentinel base origin: lets new URL() parse relative paths and lets us detect
  // origin escapes (e.g. /foo/..//evil.com normalizes to a different origin).
  // .local is RFC 6762-reserved so it can never collide with a real domain.
  let parsed: URL
  try {
    parsed = new URL(input, 'http://x.local')
  } catch {
    return null
  }
  if (parsed.origin !== 'http://x.local') return null
  if (parsed.pathname.startsWith('//') || parsed.pathname.startsWith('\\')) return null

  const safe = parsed.pathname + parsed.search + parsed.hash
  if (safe === '/') return null
  return safe
}
